var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeafBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 575,
    viewBox: "0 0 515 575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-44.4133 13.9329L-32.824 17.0388C-32.824 17.0388 -66.42 110.253 70.9965 275.205C139.724 357.707 200.377 404.96 200.377 404.96C200.377 404.96 -62.745 202.493 -44.4133 13.9329Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.57 364.371C-63.57 364.371 -8.85044 263.412 -4.36996 229.412C0.0942037 195.408 -0.701444 179.887 -15.2305 151.82C-16.912 160.641 -36.0061 209.491 -44.2369 229.684C-52.4677 249.877 -63.1695 307.627 -63.57 364.371Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8699 205.354C14.8699 205.354 13.9211 241.189 4.72475 265.593C-4.47157 289.997 -3.13172 378.169 17.2117 422.515C19.1473 392.683 31.8996 314.641 32.2549 280.405C32.6102 246.168 27.4182 234.895 14.8699 205.354Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.945 482.897C122.945 482.897 60.359 402.797 57.3085 349.178C54.258 295.559 53.7295 281.222 46.9917 261.467C61.0582 282.791 73.7948 319.493 79.443 339.967C85.1076 360.444 98.5625 445.324 122.945 482.897Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.897 516.99C186.897 516.99 156.679 391.469 137.458 364.94C118.226 338.388 93.4695 313.668 93.4695 313.668C93.4695 313.668 111.66 352.975 116.437 363.747C121.231 374.523 132.99 425.431 142.391 445.608C151.804 465.808 168.907 489.228 186.897 516.99Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.676 376.916C170.212 384.17 203.711 424.494 212.994 436.502C222.277 448.511 287.228 536.561 301.7 548.408C276.488 529.797 235.07 489.417 223.317 476.327C211.549 463.233 190.876 434.2 182.031 422.023C169.818 405.19 155.677 374.155 159.676 376.916Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.385 416.723C208.385 416.723 236.075 452.836 297.157 492.011C358.24 531.186 417.865 546.921 417.865 546.921C417.865 546.921 337.333 499.331 308.485 479.461C279.653 459.594 218.145 422.607 208.385 416.723Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.352 370.142C170.352 370.142 174.703 376.883 188.749 386.558C258.149 434.372 382.338 428.943 419.913 454.827C419.913 454.827 370.32 428.9 352.514 421.696C269.142 387.936 214.895 396.369 170.352 370.142Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.982 398.203C191.982 398.203 195.201 403.193 205.604 410.351C256.958 445.73 348.85 441.714 376.645 460.866C376.645 460.866 339.942 441.674 326.78 436.351C265.087 411.365 224.935 417.607 191.982 398.203Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.482 328.72C123.482 328.72 131.525 339.637 138.718 344.848C191.067 382.758 328.262 381.726 395.706 425.901C352.28 396.196 336.819 391.447 316.742 381.266C268.768 356.934 153.213 345.868 123.482 328.72Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8401 277.169C73.8401 277.169 81.9973 291.049 99.4132 302.371C152.931 337.164 285.315 345.169 312.683 366.519C312.683 366.519 303.715 359.929 281.666 347.328C223.382 314.023 93.1138 301.62 72.1219 275.983",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7141 223.632C32.7141 223.632 39.5102 237.637 55.9404 249.534C106.47 286.108 239.796 299.946 265.248 322.142C265.248 322.142 256.853 315.257 235.867 301.9C180.353 266.572 49.6547 248.512 31.113 222.39",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99145 170.281C5.99145 170.281 31.5704 206.19 48.0169 218.091C98.5466 254.664 228.125 271.852 255.06 290.415C255.06 290.415 247.607 278.701 223.877 267.69C151.133 233.933 24.5307 196.413 5.99145 170.281Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.9178 112.693C-20.9178 112.693 -17.4775 142.378 27.5672 170.035C72.6119 197.692 131.709 218.472 252.766 257.63C224.523 241.907 176.52 208.826 102.895 185.582C57.79 171.339 31.1054 158.823 19.3515 150.103C7.59994 141.373 -20.9178 112.693 -20.9178 112.693Z",
    fill: "#D7EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33.267 79.8959C-33.267 79.8959 -31.4681 101.065 9.53196 129.297C50.5133 157.536 187.922 191.743 217.08 212.765C204.029 201.905 208.267 203.89 192.991 193.369C129.902 149.908 19.8805 120.226 -6.84741 101.808C-33.5778 83.3998 -33.267 79.8959 -33.267 79.8959Z",
    fill: "#D7EED5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafBottom);
export default __webpack_public_path__ + "static/media/leaf_bottom.facddaffc4c7bf4775508a5a2dbaed51.svg";
export { ForwardRef as ReactComponent };